module.exports = __webpack_public_path__ + "static/media/linkedin.c4cfbad1.svg";